import React from 'react'
import styled from 'styled-components'
import { Avatar } from './Avatar'

export type AbwTeacherTileProps = {
	name: string
	subject?: string
	/** Profile photo URL; when absent the initials render on a tinted circle. */
	photo?: string
	initials?: string
	tint?: string
	/** Polymorphic root (e.g. a router Link) so the tile can stay a real anchor. */
	as?: React.ElementType
	className?: string
	onClick?: React.MouseEventHandler
	[key: string]: any
}

/**
 * Teacher tile (design's teachers grid): white bordered card, centred circle
 * avatar, bold name, muted subject line.
 */
export const TeacherTile: React.FC<AbwTeacherTileProps> = ({ name, subject, photo, initials, tint = 'var(--blue)', as, className, ...rest }) => (
	<Card as={as} className={className} {...rest}>
		<Avatar
			src={photo || undefined}
			emoji={!photo ? initials : undefined}
			color={tint}
			size={64}
			shape="circle"
			style={{ color: 'var(--blue)', fontWeight: 700 }}
		/>
		<span className="tile-name">{name}</span>
		{subject && <span className="tile-subject">{subject}</span>}
	</Card>
)

const Card = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 6px;
	background: var(--surface-card);
	border: 1px solid var(--border);
	border-radius: var(--r-xl);
	padding: 14px 8px;
	box-shadow: var(--sh-rest);
	cursor: pointer;
	text-align: center;
	text-decoration: none;
	transition: box-shadow var(--dur-fast) var(--ease);
	&:hover {
		box-shadow: var(--sh-hover);
	}
	.tile-name {
		font: var(--fw-bold) var(--fs-label)/1.4 var(--font-sans);
		color: var(--text-primary);
	}
	.tile-subject {
		font: var(--fw-regular) var(--fs-micro-plus) var(--font-sans);
		color: var(--text-secondary);
	}
`
